import { render } from "./AffinityGroupSelection.vue?vue&type=template&id=18172f3c&scoped=true"
import script from "./AffinityGroupSelection.vue?vue&type=script&lang=js"
export * from "./AffinityGroupSelection.vue?vue&type=script&lang=js"

import "./AffinityGroupSelection.vue?vue&type=style&index=0&id=18172f3c&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18172f3c"]])

export default __exports__